import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/tailwind-light/theme.css";
import "primeicons/primeicons.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import React from "react";
import { ToastContainer } from "react-toastify";
import RoutesIndex from "./Router";

function App() {
  return (
    <div className="from-emerald-700 via-emerald-500 to-green-400 bg-gradient-to-br h-screen w-screen">
      <ToastContainer theme="light" />
      <RoutesIndex></RoutesIndex>
    </div>
  );
}

export default App;
